import { render, staticRenderFns } from "./CorporatesView.vue?vue&type=template&id=f9d4e63e&scoped=true&"
import script from "./CorporatesView.vue?vue&type=script&lang=js&"
export * from "./CorporatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d4e63e",
  null
  
)

export default component.exports